import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speed-sensor-element',
  templateUrl: './speed-sensor-element.component.html',
  styleUrls: ['./speed-sensor-element.component.scss'],
})
export class SpeedSensorElementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
